import React from "react";
import { Link, Outlet, useParams, useSearchParams } from "react-router-dom";
import { XCircleIcon } from "@primer/octicons-react";
import { getForums } from "../data/forums";
import { getTopics } from "../data/topics";
import sortBy from "../util/sortBy";

export default function Topics() {
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const topics = sortBy(
        getTopics()
            .filter(topic => topic.forum_id.toString() === params.forumId)
            .filter(topic => {
                const filter = searchParams.get("filter");
                if (!filter) return true;
                const title = topic.topic_title.toLowerCase();
                let match = false;
                filter.split(" ").forEach(w => {
                    const word = w.toLowerCase();
                    if (title.includes(word)) {
                        match = true;
                    }
                });
                return match;
            }),
        { prop: "topic_time", desc: true, parser: (d) => new Date(d) }
    );
    const forumName = getForums().filter(forum => forum.forum_id.toString() === params.forumId)[0]?.forum_name ?? "";

    let filterTimeout;
    const filterTopics = query => {
        clearTimeout(filterTimeout);
        if (!query) setSearchParams({});

        filterTimeout = setTimeout(() => {
            setSearchParams({ filter: query });
        }, 500)
    };

    const clearFilter = React.useCallback(() => {
        if (searchParams.get("filter") !== "") {
            document.getElementById("filter").value = "";
            setSearchParams({ filter: "" });
        }
    }, [searchParams, setSearchParams]);

    return (
        <div>
            {!params.topicId && <>
                <div className="py-2 sticky bg-slate-200 flex flex-wrap justify-between items-center" style={{ top: "5.625rem" }}>
                    <h3>
                        <Link className="no-underline text-slate-800" to="/">Forums</Link>
                        &nbsp;&raquo;&nbsp;
                        {forumName !== "" ? forumName : "Topics"}
                    </h3>
                    <div className="relative">
                        <input
                            id="filter"
                            type="text"
                            className="p-2 bg-grey-100 border-slate-300 italic rounded-md border-gray-300 focus:border-gray-300 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50"
                            placeholder="filter..."
                            onChange={evt => filterTopics(evt.target.value)}
                        />
                        <a
                            href="#"
                            className="absolute text-slate-400 cursor-pointer"
                            style={{ top: "6px", right: "10px" }}
                            onClick={evt => { evt.preventDefault(); clearFilter(); }}
                            title="Clear Filter"
                        ><XCircleIcon /></a>
                    </div>
                </div>
                <table className="table-auto border-collapse border border-slate-400 w-full">
                    <thead className="bg-slate-700 text-slate-50 sticky" style={{ top: "148px" }}>
                        <tr>
                            <th className="text-left p-3 border border-slate-400">Title</th>
                            <th className="text-left p-3 border border-slate-400">Last Posted</th>
                        </tr>
                    </thead>
                    <tbody className="bg-slate-50">
                        {topics.map(topic => (
                            <tr key={topic.topic_id}>
                                <td className="text-left py-2 px-3 border border-slate-400">
                                    <Link className="no-underline text-slate-800" to={`/forums/${topic.forum_id}/topics/${topic.topic_id}`}>{topic.topic_title}</Link>
                                </td>
                                <td className="text-left py-2 px-3 border border-slate-400">
                                    {new Date(topic.topic_time).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>}
            <Outlet />
        </div>
    );
}